import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getUserMenuList } from "../../../application/selectors/user";
import Dashboard from "../../components/dashboard";
import BreadcrumbsComponent from "../../components/shared/breadcrumbs";
import AdminDatabaseBackupCard from "./AdminDatabaseBackupCard";

const ADMIN_MODULE_LINK = "/admin";

const AdminOpsHubPage = () => {
  const menuList = useSelector(getUserMenuList);
  const [moduleMenu, setModuleMenu] = useState({ title: "مدیریت اجرایی", child: [] });

  useEffect(() => {
    if (!Array.isArray(menuList)) return;
    const item = menuList.find(
      (x) => x.link === ADMIN_MODULE_LINK || x.oldLink === "admin"
    );
    if (item) {
      setModuleMenu(item);
    }
  }, [menuList]);

  const subMenus = Array.isArray(moduleMenu.child) ? moduleMenu.child : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12}>
        <AdminDatabaseBackupCard />
      </Grid>
      <Grid item xs={12}>
        <Dashboard menuList={subMenus} cartTitle={moduleMenu.title} />
      </Grid>
    </Grid>
  );
};

export default AdminOpsHubPage;
